import { createStore, createEvent } from 'effector';

export const $showNotification = createStore(false);
export const $notificationMessage = createStore("");
export const $severity = createStore("error");

export const setShowNotification = createEvent();
export const setNotificationMessage = createEvent();
export const setSeverity = createEvent();

$showNotification
    .on(setShowNotification, (_, value) => value);
$notificationMessage
    .on(setNotificationMessage, (_, value) => value);
$severity
    .on(setSeverity, (_, value) => value);